import './CompareWorkshops.css';
import CompareWorkshopsRow from './CompareWorkshopsRow';

const CompareWorkshopsInfo = ({ comparedWorkshops, comparedWorkshopDetails }) => {
    
    return (
        <div className='mb-6'>
            <CompareWorkshopsRow
                title="Id"
                property="generalInfo.id"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}                
            />
            <CompareWorkshopsRow
                title="Name"
                property="generalInfo.name"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}                
            />
            <CompareWorkshopsRow
                title="Country"
                property="reportAutomationVariables.text_workshop_country"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}                
            />
            <CompareWorkshopsRow
                title="Location"
                property="reportAutomationVariables.text_workshop_location"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}                
            />
            <CompareWorkshopsRow
                title="Date"
                property="reportAutomationVariables.text_workshop_date"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}                
            />
            <CompareWorkshopsRow
                title="Organizer"
                property="reportAutomationVariables.text_organizing_partners"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <CompareWorkshopsRow
                title="Participants"
                property="reportAutomationVariables.text_participants_number"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <CompareWorkshopsRow
                title="Average age"
                property="participantStats.avg_age"
                comparedWorkshops={comparedWorkshops}
                workshopDetails={comparedWorkshopDetails}
            />
            <div className="columns">
                <div className='column is-2 mt-3 mb-3'>
                    <div className='title is-5'>
                        Land use
                    </div>
                </div>
                {comparedWorkshops.map((workshop, index) => (                    
                    <div key={workshop.id} className='column has-background-white m-3'>                    
                        {comparedWorkshopDetails[index].landUseTypes.map(type => type.name).join(", ")}                    
                    </div>
                ))}
            </div>
            <div className="columns">
                <div className='column is-2 mt-3 mb-3'>
                    <div className='title is-5'>
                        Stakeholders involved
                    </div>
                </div>
                {comparedWorkshops.map((workshop, index) => (                    
                    <div key={workshop.id} className='column has-background-white m-3'>
                        <ul>
                            {Array.isArray(comparedWorkshopDetails[index].stakeholderStats) && comparedWorkshopDetails[index].stakeholderStats.map((item, index) => (
                            <li key={index}>{item.stakeholder_type_name}: {item.count}</li>
                        ))}
                        </ul>
                    </div>                    
                ))}            
            </div>
        </div>
    );
};

export default CompareWorkshopsInfo;
